import type { PathwayId } from '@ircf/config';
import type { ButtonPathway } from '@ircf/ui';

/**
 * Bridges the config pathway identifier to the design system's accent token.
 *
 * The two vocabularies differ on purpose: `@ircf/config` uses the route-facing
 * slug `personal-training`, while `@ircf/ui` uses the shorter accent name `pt` and
 * knows nothing about routes. This is the one place the two meet.
 */
export function buttonPathway(pathway: PathwayId): ButtonPathway {
  switch (pathway) {
    case 'personal-training':
      return 'pt';
    case 'boxing':
      return 'boxing';
    default:
      return 'master';
  }
}

/** Tailwind text colour for a pathway accent. */
export function accentTextClass(pathway: PathwayId): string {
  switch (pathway) {
    case 'personal-training':
      return 'text-accent-pt';
    case 'boxing':
      return 'text-accent-boxing';
    default:
      return 'text-warm-white';
  }
}

/** Tailwind border colour for a pathway accent. */
export function accentBorderClass(pathway: PathwayId): string {
  switch (pathway) {
    case 'personal-training':
      return 'border-accent-pt';
    case 'boxing':
      return 'border-accent-boxing';
    default:
      return 'border-warm-white';
  }
}

/** Tailwind background colour for a pathway accent. */
export function accentBgClass(pathway: PathwayId): string {
  switch (pathway) {
    case 'personal-training':
      return 'bg-accent-pt';
    case 'boxing':
      return 'bg-accent-boxing';
    default:
      return 'bg-warm-white';
  }
}
